import React from 'react';
import {connect} from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import css from './Header.module.css';
import {setShowFilters, setShowSettings} from "../../../store/coreSlice";
import SettingsIcon from '@material-ui/icons/Settings';
import Shortcuts from "./Shortcuts";
import {useMediaQuery, useTheme} from "@material-ui/core";


const Header = (props) => {
	const theme = useTheme();
	const isSmall = useMediaQuery(theme.breakpoints.down('xs'));

	const onClickHamburger = () => {
		props.setShowFilters(true);
	};

	return (
		<AppBar position="static">
			<Toolbar>
				<IconButton edge="start" onClick={onClickHamburger} className={css.menuButton} color="inherit" aria-label="menu">
					<MenuIcon />
				</IconButton>
				<Typography variant="h6" className={css.Title}>
					<a href='/' className={css.titleLink}>{isSmall ? "A2PoGo" : "Ann Arbor Pokemon Go"}</a> - Map
				</Typography>
				<Shortcuts/>
				<IconButton
					onClick={() => props.setShowSettings(true)}
					color="inherit"
				>
					<SettingsIcon />
				</IconButton>
			</Toolbar>
		</AppBar>
	);
};



const mapDispatchToProps = (dispatch) => {
	return {
		setShowFilters: (val) => dispatch(setShowFilters(val)),
		setShowSettings: (val) => dispatch(setShowSettings(val)),
	};
};

export default connect(null, mapDispatchToProps)(Header);